import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface SecretSectionProps {
  onAuthenticated?: () => void;
}
interface RevengeStory {
  id: string;
  title: string;
  content: React.ReactNode;
}
const REVENGE_STORIES: RevengeStory[] = [{
  id: 'revenge1',
  title: "MGM Dies in a Tragic 12 Car Pile Up, Cedrine Dion Marry's Prince Harry",
  content: <div className="space-y-3" data-id="element-123">
        <p data-id="element-124">
          It was a dark and stormy night on the highway. MGM was driving his
          stupid ugly car (probably a Pontiac Sunfire lol) when suddenly TWELVE
          cars came out of NOWHERE and crashed into him from every direction!!!
        </p>
        <p data-id="element-125">
          Meanwhile, Cedrine was at Buckingham Palace having tea with the Queen
          when Prince Harry walked in. "Cedrine," he said, getting down on one
          knee, "you are the most talented and beautiful woman in the world.
          Will you marry me?"
        </p>
        <p data-id="element-126">
          "Yes!!!" Cedrine said, and her engagement ring was 47 carats. They
          lived happily ever after in a castle made of platinum records. 💍👑
        </p>
        <p className="text-xs opacity-60 mt-4" data-id="element-127">
          A/N: This is FICTION obviously!!! But wouldn't it be amazing??? 😍
        </p>
      </div>
}, {
  id: 'revenge2',
  title: 'MGM Gets Kidnapped by ISIS',
  content: <div className="space-y-3" data-id="element-128">
        <p data-id="element-129">
          One day MGM was being a jerk as usual, talking trash about Cedrine on
          MTV, when a mysterious van pulled up.
        </p>
        <p data-id="element-130">"Get in the van, MGM," they said. And he did because he's STUPID.</p>
        <p data-id="element-131">
          They took him to a desert island with no music, no microphones, and NO
          AUTOTUNE (which he NEEDS because he can't actually sing!!!). He had to
          listen to Cedrine's albums on repeat for the rest of his life as
          punishment.
        </p>
        <p data-id="element-132">
          "NOOOO!" he screamed. But nobody cared. Because he's MGM. And nobody
          likes MGM. 😤
        </p>
        <p className="text-xs opacity-60 mt-4" data-id="element-133">
          A/N: He deserves it for what he said in Tiger Beat!!!
        </p>
      </div>
}, {
  id: 'revenge3',
  title: 'Machine Gun Mikey Gets Machine Gunned',
  content: <div className="space-y-3" data-id="element-134">
        <p data-id="element-135">
          They called him Machine Gun Mikey because he thought he was SO cool
          and SO tough. But guess what??? He's NOT.
        </p>
        <p data-id="element-136">
          One day at the VMAs, Cedrine was about to accept her award for Best
          Artist of All Time (FINALLY the recognition she deserves!!!) when MGM
          tried to rush the stage.
        </p>
        <p data-id="element-137">
          But the security guards had WATER GUNS filled with Cedrine's new
          perfume "Eternal Sparkle" and they BLASTED him right off the stage!!!
          He smelled like roses and vanilla for WEEKS and everyone laughed at
          him at school. I mean... at his concerts. Which nobody goes to anyway.
          💀😂
        </p>
        <p className="text-xs opacity-60 mt-4" data-id="element-138">
          A/N: The water guns part is a metaphor. For JUSTICE.
        </p>
      </div>
}, {
  id: 'revenge4',
  title: 'Sweet Cedrine Takes Matters Into Her Own Hands (Sweet Revenge)',
  content: <div className="space-y-3" data-id="element-139">
        <p data-id="element-140">
          Cedrine had had ENOUGH. After years of MGM talking trash, spreading
          lies, and being the WORST person in the music industry, she decided to
          destroy him the only way she knew how.
        </p>
        <p data-id="element-141">She released a diss track.</p>
        <p data-id="element-142">
          It was called "Boy, Bye 💅" and it went TRIPLE PLATINUM in ONE DAY.
          Every lyric was about how MGM can't sing, can't dance, and his hair
          looks stupid. The chorus went:{' '}
          <em data-id="element-143">
            "You thought you were somebody, but you're just a nobody, boy bye
            bye bye!!!"
          </em>
        </p>
        <p data-id="element-144">
          MGM's career was OVER. He had to get a job at Subway. Not even the
          good Subway. The one at the gas station. Cedrine won a Grammy for the
          track and dedicated it to "all the haters who made me stronger." 👑✨
        </p>
        <p className="font-bold mt-4" data-id="element-145">
          THE END. Cedrine wins. She always wins. 💖
        </p>
        <p className="text-xs opacity-60" data-id="element-146">
          A/N: This is my favorite one I've ever written. I cried writing the
          chorus part. Cedrine if you're reading this PLEASE make this a real
          song!!!
        </p>
      </div>
}];
export function SecretSection({
  onAuthenticated
}: SecretSectionProps) {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState(false);
  const [expandedId, setExpandedId] = useState<string | null>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.toLowerCase().trim() === 'marie') {
      setIsAuthenticated(true);
      setError(false);
      onAuthenticated?.();
    } else {
      setError(true);
      setPassword('');
    }
  };
  return <section id="secret" className="w-full max-w-3xl mx-auto mb-12" data-id="element-147">
      <div className={`retro-border p-6 relative overflow-hidden ${isAuthenticated ? 'bg-black shadow-[0_0_40px_#ff0000]' : 'bg-black shadow-[0_0_20px_#ff00ff]'}`} data-id="element-148">
        {/* Pulsing border effect */}
        <div className={`absolute inset-0 border-4 animate-pulse pointer-events-none ${isAuthenticated ? 'border-red-600' : 'border-[#00ff00]'}`} data-id="element-149"></div>

        <h2 className={`text-4xl text-center mb-6 tracking-widest ${isAuthenticated ? 'text-red-500' : 'text-[#00ff00]'}`} style={{
        textShadow: isAuthenticated ? '0 0 10px #ff0000, 0 0 20px #660000' : undefined
      }} data-id="element-150">
          {isAuthenticated ? '💀 THE DARK ZONE 💀' : '🔒 SUPER SECRET REAL FANS ONLY ZONE 🔒'}
        </h2>

        <AnimatePresence mode="wait" data-id="element-151">
          {!isAuthenticated ? <motion.div key="login" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="bg-[#111] border border-[#333] p-8 text-center" data-id="element-152">
              <p className="text-[#ff66cc] text-xl mb-6 font-bold" style={{
            textShadow: '1px 1px 2px #000'
          }} data-id="element-153">
                HALT!!! 🛑 Only TRUE fans can enter this zone!!!
              </p>

              <form onSubmit={handleSubmit} className="flex flex-col items-center gap-4" data-id="element-154">
                <label className="text-white text-lg font-bold" style={{
              textShadow: '1px 1px 2px #000'
            }} data-id="element-155">
                  Question: What is Cedrine's real birth name?
                </label>
                <input type="text" value={password} onChange={e => setPassword(e.target.value)} className="bg-white text-black px-4 py-2 border-4 border-[#ff1493] w-64 text-center font-bold" placeholder="Enter answer here..." data-id="element-156" />
                <button type="submit" className="bg-[#00ff00] text-black font-bold px-8 py-2 border-4 border-white hover:bg-[#ff1493] hover:text-white transition-colors" data-id="element-157">
                  ENTER THE ZONE
                </button>
              </form>

              {error && <div className="mt-6 text-red-500 font-bold text-2xl animate-blink" data-id="element-158">
                  WRONG!!! You are NOT a real fan!!! 😤 FAKE FAN ALERT!!! 🚨
                </div>}
            </motion.div> : <motion.div key="content" initial={{
          scale: 0.8,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.5
        }} className="bg-[#0a0000] border-2 border-red-800 p-6" data-id="element-159">
              <div className="text-center mb-6" data-id="element-160">
                <img src="https://cdn.magicpatterns.com/uploads/uFoHNyW6jcDoguNwUxDwK3/download.jpg" alt="Cedrine for TRUE fans only" className="mx-auto w-48 h-48 object-cover border-4 border-red-600 mb-4" style={{
              filter: 'grayscale(50%) brightness(0.8) sepia(20%)'
            }} data-id="element-161" />
              </div>

              <h3 className="text-2xl text-red-500 text-center mb-2 font-bold" style={{
            textShadow: '0 0 8px #ff0000'
          }} data-id="element-162">
                Welcome to the DARK side, true fan... 🖤
              </h3>
              <p className="text-red-400 text-center mb-8 text-sm" data-id="element-163">
                These stories are for REAL fans ONLY. If you like MGM, GET OUT
                NOW!!! 😡
              </p>

              <div className="space-y-6" data-id="element-164">
                {REVENGE_STORIES.map((story, index) => <motion.div key={story.id} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: index * 0.15
            }} className="bg-[#1a0000] border-2 border-red-900 p-5" style={{
              boxShadow: '3px 3px 0px #440000'
            }} data-id="element-165">
                    <h4 className="text-lg md:text-xl text-red-400 font-bold mb-1" data-id="element-166">
                      💀 {story.title}
                    </h4>
                    <div className="text-xs text-red-800 mb-3" data-id="element-167">
                      by CedrineLuvr4eva | Rated: R for REVENGE
                    </div>

                    {expandedId === story.id ? <div className="text-red-300 text-base" data-id="element-168">
                        {story.content}
                        <button onClick={() => setExpandedId(null)} className="mt-4 text-red-500 hover:text-red-300 underline font-bold text-base bg-transparent border-none" style={{
                  background: 'transparent'
                }} data-id="element-169">
                          [Hide Story]
                        </button>
                      </div> : <button onClick={() => setExpandedId(story.id)} className="bg-red-900 text-red-300 px-4 py-1.5 border-2 border-red-600 hover:bg-red-700 font-bold text-base" data-id="element-170">
                        Read Story 💀
                      </button>}
                  </motion.div>)}
              </div>

              <div className="mt-8 text-center" data-id="element-171">
                <div className="bg-gradient-to-r from-red-900 to-red-800 p-6 text-center border-4 border-dashed border-red-500 transform -rotate-1" data-id="element-172">
                  <h4 className="text-2xl mb-2 text-red-400" data-id="element-173">
                    Official Anti-MGM Club Member
                  </h4>
                  <p className="font-mono text-sm mb-2 text-red-500" data-id="element-174">
                    ID: #0000001
                  </p>
                  <p className="text-sm text-red-300" data-id="element-175">
                    Print this out and burn it at the next MGM concert (jk...
                    unless? 👀)
                  </p>
                </div>
              </div>

              <div className="text-center text-red-600 font-bold text-lg mt-6 animate-blink" data-id="element-176">
                IF YOU SHARE THESE STORIES WITH MGM FANS I WILL FIND YOU!!! 💀🔪
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </section>;
}